<template>
  <datatable :type="'workers'" :rowData="workers" :compliance="'recruitment'" :loadingMessage="loadingMessage" :noRowsMessage="noRowsMessage" :columns="columns"
             :paginationSize="50"></datatable>
</template>
<script>
import datatable from "datatables/datatable";

export default {
  name: "worker_compliance",
  components: {
    datatable,
  },
  data() {
    return {
      workers: null,
      loadingMessage: 'Loading Workers...',
      noRowsMessage: 'No Workers Found',
      columns: [],

      uk_ireland: ['United Kingdom (UK)', 'Wales', 'Scotland', 'Northern Ireland', 'England', 'Republic of Ireland'],
      eu: ['Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic', 'Denmark', 'Estonia', 'Finland', 'France', 'Germany', 'Greece',
        'Hungary', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'The Netherlands', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden']
    }
  },
  beforeMount() {
    if (process.env.MIX_CRM_TYPE === 'recruitment') {
      this.columns = [
        {headerName: 'Ref', width: 100, suppressSizeToFit: true, valueGetter: this.ref_vg, pinned: 'left'},
        {headerName: 'First Name', minWidth: 125, maxWidth: 250, pinned: 'left', field: 'first_name'},
        {headerName: 'Surname', minWidth: 125, maxWidth: 250, pinned: 'left', field: 'surname'},
        {headerName: 'Compliant', minWidth: 115, maxWidth: 115, pinned: 'left', field: 'worker_compliant'},
        {headerName: 'Working For', minWidth: 300, valueGetter: this.working_for_vg, cellStyle: {'white-space': 'pre-wrap'}},
        {headerName: 'Email', minWidth: 225, field: 'email_address'},
        {headerName: 'Mobile', minWidth: 100, suppressSizeToFit: true, field: 'mobile_number'},

        {headerName: 'Employment Type', minWidth: 150, suppressSizeToFit: true, field: 'employment_type'},
        {headerName: 'NI Number', minWidth: 125, suppressSizeToFit: true, field: 'ni_number'},
        // {headerName: 'Personal UTR Number', minWidth: 125, suppressSizeToFit: true, field: 'personal_utr_number'},
        // {headerName: 'Trading Name', minWidth: 125, suppressSizeToFit: true, field: 'company_trading_name'},
        // {headerName: 'Ltd Reg Number', minWidth: 125, suppressSizeToFit: true, field: 'company_ltd_reg_number'},

        {headerName: 'Date of Birth', minWidth: 125, suppressSizeToFit: true, valueGetter: this.dob_vg},
        {headerName: 'Address', minWidth: 225, field: 'address'},
        {headerName: 'UK Citizen', minWidth: 175, field: 'is_uk_citizen'},
        {headerName: 'Country of Birth', minWidth: 175, field: 'country_name'},
        {headerName: 'R2W Region', minWidth: 150, field: 'r2w_region'},
        {headerName: 'Proof of ID', minWidth: 115, field: 'compliance_passport', cellStyle: {'justify-content': 'center'}},
        // {headerName: 'Proof of Address', minWidth: 150, field: 'compliance_address', cellStyle: {'justify-content': 'center'}},
        {headerName: 'Proof of UK R2W', minWidth: 150, field: 'uk_r2w', cellStyle: {'justify-content': 'center'}},
        {headerName: 'Uploaded File Compliant', minWidth: 150, field: 'compliance_compliance', cellStyle: {'justify-content': 'center'}},

        {headerName: 'Criminal Convictions', minWidth: 225, maxWidth: 300, field: 'any_criminal_convictions'},
        {headerName: 'Criminal Conviction Details', minWidth: 225, maxWidth: 300, field: 'criminal_convictions_details'},

        {headerName: 'Bank Name', minWidth: 225, maxWidth: 300, field: 'bank_name'},
        {headerName: 'Bank Account Name', minWidth: 225, maxWidth: 300, field: 'accounts_holder'},
        {headerName: 'Bank Account Number', minWidth: 225, maxWidth: 300, field: 'account_number'},
        {headerName: 'Bank Sort Code', minWidth: 225, maxWidth: 300, field: 'sort_code'},

        {headerName: 'Next of Kin', minWidth: 225, maxWidth: 300, field: 'nok_name'},
        {headerName: 'NoK Contact Number', minWidth: 225, maxWidth: 300, field: 'nok_contact_number'},
        {headerName: 'Reference', minWidth: 225, maxWidth: 300, valueGetter: this.reference_vg, cellStyle: {'white-space': 'pre-wrap'}},
      ]
    }
    else if (process.env.MIX_CRM_TYPE === 'payroll') {
      this.columns = [
        {headerName: 'Ref', width: 100, suppressSizeToFit: true, valueGetter: this.ref_vg, pinned: 'left'},
        {headerName: 'First Name', minWidth: 125, maxWidth: 250, pinned: 'left', field: 'first_name'},
        {headerName: 'Surname', minWidth: 125, maxWidth: 250, pinned: 'left', field: 'surname'},
        {headerName: 'Compliant', minWidth: 115, maxWidth: 115, pinned: 'left', field: 'worker_compliant'},
        {headerName: 'Working For', minWidth: 300, valueGetter: this.working_for_vg, cellStyle: {'white-space': 'pre-wrap'}},
        {headerName: 'Email', minWidth: 225, field: 'email_address'},
        {headerName: 'Mobile', minWidth: 100, suppressSizeToFit: true, field: 'mobile_number'},
        {headerName: 'Employment Type', minWidth: 175, suppressSizeToFit: true, field: 'employment_type'},
        {headerName: 'NI Number', minWidth: 125, suppressSizeToFit: true, field: 'ni_number'},
        {headerName: 'CIS Tax Treatment', minWidth: 125, suppressSizeToFit: true, field: 'tax_treatment'},
        {headerName: 'Personal UTR Number', minWidth: 125, suppressSizeToFit: true, field: 'personal_utr_number'},
        {headerName: 'Trading Name', minWidth: 135, suppressSizeToFit: true, field: 'company_trading_name'},
        {headerName: 'Company UTR', minWidth: 135, suppressSizeToFit: true, field: 'company_utr_number'},
        {headerName: 'Ltd Reg Number', minWidth: 140, suppressSizeToFit: true, field: 'company_ltd_reg_number'},
        {headerName: 'Date of Birth', minWidth: 125, suppressSizeToFit: true, valueGetter: this.dob_vg},
        {headerName: 'Address', minWidth: 225, field: 'address'},
        {headerName: 'UK Citizen', minWidth: 175, field: 'is_uk_citizen'},
        {headerName: 'Country of Birth', minWidth: 175, field: 'country_name'},
        {headerName: 'R2W Region', minWidth: 150, field: 'r2w_region'},
        {headerName: 'Proof of ID', minWidth: 115, field: 'compliance_passport', cellStyle: {'justify-content': 'center'}},
        {headerName: 'Proof of Address', minWidth: 150, field: 'compliance_address', cellStyle: {'justify-content': 'center'}},
        {headerName: 'Proof of UK R2W', minWidth: 150, field: 'uk_r2w', cellStyle: {'justify-content': 'center'}},
        {headerName: 'Uploaded File Compliant', minWidth: 150, field: 'compliance_compliance', cellStyle: {'justify-content': 'center'}},
        {headerName: 'Bank Name', minWidth: 225, maxWidth: 300, field: 'bank_name'},
        {headerName: 'Bank Account Name', minWidth: 225, maxWidth: 300, field: 'accounts_holder'},
        {headerName: 'Bank Account Number', minWidth: 225, maxWidth: 300, field: 'account_number'},
        {headerName: 'Bank Sort Code', minWidth: 225, maxWidth: 300, field: 'sort_code'},
        {headerName: 'Company Bank Name', minWidth: 225, maxWidth: 300, field: 'company_bank_name'},
        {headerName: 'Company Bank Account Name', minWidth: 225, maxWidth: 300, field: 'company_accounts_holder'},
        {headerName: 'Company Bank Account Number', minWidth: 225, maxWidth: 300, field: 'company_account_number'},
        {headerName: 'Company Bank Sort Code', minWidth: 225, maxWidth: 300, field: 'company_sort_code'},
      ]
    }
  },
  mounted() {
    this.get_workers();
  },
  methods: {
    get_workers() {
      axios.get(this.crmApiPath + 'worker/compliance/recruitment').then(res => this.workers = res.data);
    },
    ref_vg(params) {
      if (params.data.employment_type_id === 32 && params.data.company_internal_finance_ref !== null) {
        return params.data.company_internal_finance_ref;
      }
      else {
        return params.data.internal_finance_ref;
      }
      // return params.data.company_internal_finance_ref === null ? params.data.internal_finance_ref : params.data.company_internal_finance_ref;
    },
    dob_vg(params) {
      return this.$options.filters.formatDate(params.data.dob);
    },

    working_for_vg(params) {
      // website login email
      if (Object.keys(params.data.unique_company_assignments).length > 0) {
        let temp = '';
        for (let i = 0; i < Object.keys(params.data.unique_company_assignments).length; i++) {
          if (i > 0) {
            temp += "\n";
          }
          temp += params.data.unique_company_assignments[i].company_name;
        }
        return temp;
      }
    },
    assigned_vg(params) {
      return this.$options.filters.formatDateTime(params.data.created_at);
    },
    reference_vg(params) {
      let return_reference = params.data.reference_1_name === null ? '' : params.data.reference_1_name;
      let reference_1_company_relationship = params.data.reference_1_company_relationship === null ? '' : params.data.reference_1_company_relationship;
      if (return_reference !== '' && reference_1_company_relationship !== '') {
        return_reference += "\n" + reference_1_company_relationship
      }
      else if (reference_1_company_relationship !== '') {
        return_reference = reference_1_company_relationship;
      }
      let reference_1_telephone = params.data.reference_1_telephone === null ? '' : params.data.reference_1_telephone;
      if (return_reference !== '' && reference_1_telephone !== '') {
        return_reference += "\n" + reference_1_telephone
      }
      else if (reference_1_telephone !== '') {
        return_reference = reference_1_telephone;
      }
      let reference_1_email = params.data.reference_1_email === null ? '' : params.data.reference_1_email;
      if (return_reference !== '' && reference_1_email !== '') {
        return_reference += "\n" + reference_1_email
      }
      else if (reference_1_email !== '') {
        return_reference = reference_1_email;
      }
      return return_reference;
    }
  }
}
</script>

<style scoped>

</style>
